import React, { useState, useEffect } from "react";
import './shortlisting.css';

import { GET_SHORTLISTING_CRITERIA, UPDATE_STAKEHOLDER_REGISTRATION_STATUS, GET_STAKEHOLDERS_FOR_SYSTEM_AUTO_SHORTLIST, ADD_SHORTLIST_CRITERIA, ADD_BULK_PINCODE } from '../../common/URLs';
import { useNavigate } from "react-router-dom";
import { Stakeholder_Type, SHORTLIST, WAITLIST, PINCODE_NO_ERROR, FILE_NAME_VALIDATION_ERROR } from "../../common/constants";
import { loaderService } from "../../common/custom-loader/loader-service";
import { Delete as DeleteIcon, Download as DownloadIcon } from '@mui/icons-material';
import { Row, Col } from 'react-bootstrap';
import { Container, Card, Link, CardContent, IconButton, Button, Tab, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField, Tooltip } from '@mui/material';
import { addressMaxLength, fileNameValidation, mobileNoMaxLength, pincodeMaxLength, pincodeValidation, shortListWaitlistMaxcount, typeNumberValid, urnMaxLength } from '../../common/commonValidations';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { PROD } from "../../common/constants";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus, lastFiveDigitsComparator } from "../../common/commonFunction";
import { useTranslation } from 'react-i18next';
import { AddIcon, SaveIcon, SearchIcon, ShortlistIcon, UploadIcon, WaitlistIcon } from "../../common/icons";
import apiClient from "../../axios";
import BadgeComponent from "../../common/badge";

function Shortlisting() {
    const location = useLocation();
    const { t } = useTranslation();
    const [details, setDetails] = useState({
        pincode: '',
        landAreaInSqft: '',
        noOfClumps: ''
    });
    const [errorMessage, setErrorMessage] = useState({
        pincodeError: '',
        landareaError: '',
        clumpsError: '',
        fileuploadError: ''
    });
    const [shortlistingCriteria, setShortlistingCriteria] = useState(true);
    const [shortlisting, setShortlisting] = useState(false);

    const [pincode, setPincode] = useState();
    const [searchFilter, setSearchFilter] = useState({
        stakeHolderType: 'All',
        URN: '',
    });
    const [clumpsValue, setClumpsValue] = useState();
    const [landAreaInSqft, setLandAreaInSqft] = useState();
    const [uploadDetails, setUploadDetails] = useState();
    const [autoShortlisted, setAutoShortlisted] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [pincodeArray, setPincodeArray] = useState();
    const [updatePincode, setUpdatePincode] = useState();
    const [shortlistDetails, setShortlistDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [selectAll, setSelectAll] = useState(false);
    const [itemChecked, setItemChecked] = useState([]);
    const [shortlistWaitlist, setShortlistWaitlist] = useState();
    const [active, setActive] = useState(true);
    const [pincodeSearch, setPincodeSearch] = useState('');
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [action, setAction] = useState();
    const [saveType, setSaveType] = useState();
    const navigate = useNavigate();
    const [tabValue, setTabValue] = React.useState('1');
    const [page, setPage] = useState(0);
    const [updatedPincodes, setUpdatedPincodes] = useState([]);
    const extensionList = ['xls', 'xlsx', 'xlsm'];
    const [updateStakeholderStatus, setUpdateStakeholderStatus] = useState([]);

    useEffect(() => {
        getShortlistCriteria();
    }, []);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function getShortlistCriteria() {
        loaderService.showLoader();
        apiClient.post(GET_SHORTLISTING_CRITERIA,
            {

            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                setDetails({ ...details, noOfClumps: response.data.shortlistConfig.noOfClumps, landAreaInSqft: response.data.shortlistConfig.landAreaInSqft })
                setPincode(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }

    const pincodeArr = pincode?.shortlistConfig?.pinCodes;
    const clumpsValues = clumpsValue?.shortlistConfig?.noOfClumps;
    const landAreaInSqfts = landAreaInSqft?.shortlistConfig?.landAreaInSqft;


    useEffect(() => {
        if (pincodeArr) {
            setPincodeArray(pincodeArr)
        }

    }, [pincodeArr]);

    const onDeletePincode = (pincode) => {
        var rows = pincodeArray.filter(item => item.pincode != pincode);
        setPincodeArray(rows);
        var tempArr = [...updatedPincodes];
        tempArr.push({
            pincode: pincode,
            isActive: false,
        });
        setUpdatedPincodes(tempArr);
    };

    useEffect(() => {
        getStakeholdersSystemAutoShortlist();
    }, []);

    useEffect(() => {
        if (location?.state?.page) {
            setPage(location?.state?.page)
        }
        if (location?.state?.tabValue) {
            setTabValue(location?.state?.tabValue)
        }
    }, [location?.state?.page, location?.state?.tabValue]);

    function searchShortlist(e) {
        e.preventDefault();
        getStakeholdersSystemAutoShortlist();
    }
    function getStakeholdersSystemAutoShortlist() {
        loaderService.showLoader();
        var type = searchFilter.stakeHolderType;
        if (type == 'Interim Storage Operator') {
            type = 'InterimStorageOperator';
        }
        apiClient
            .post(GET_STAKEHOLDERS_FOR_SYSTEM_AUTO_SHORTLIST,
                {
                    "type": type,
                    "urn": searchFilter.URN,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                        "Content-Type": "application/json"
                    }
                }, null
            )
            .then((response) => {
                setAutoShortlisted(response.data.stakeHolders);
                loaderService.hideLoader();

            })

            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }
    // const onClickShortlistWaitlist = (e, action) => {
    //     e.preventDefault();
    //     if (selectedRows.length == 0) {
    //         toast.error("Please select stakeholders to shortlist/ waitlist.");
    //     }
    //     else {
    //         setAction(action);
    //         setSaveType("shortlist");
    //         handleConfirmLogModalOpen();
    //     }
    // }

    const onClickShortlistWaitlist = (e, action) => {
        e.preventDefault();
        if (selectedRows?.length == 0) {
            toast.error("Please select stakeholders to shortlist/ waitlist.");
        }
        else {
            const selectedStakeholders = autoShortlisted?.filter(c => selectedRows.includes(c.urn));
            const differentRegStatus = selectedStakeholders?.filter(c => c.registrationStatus !== action);
            // const sameStatusCount = selectedStakeholders.length - differentRegStatus.length;

            if (differentRegStatus.length === 0) {
                toast.error(`At least one candidate should not already be '${action}'`);
                return;
            }

            const idsToUpdate = differentRegStatus?.map(c => c.urn);
            setUpdateStakeholderStatus(idsToUpdate)
            setAction(action);
            setSaveType("shortlist");
            handleConfirmLogModalOpen();
        }
    };

    function onConfirmCallBack() {
        handleConfirmLogModalClose();
        if (saveType == "shortlist") {
            shortListWaitListStakeholders();
        }
        else {
            addShortlistingCriteria();
        }
    }

    const onClickChecked = (e, urn) => {
        let tempARR = [...itemChecked]
        var index = tempARR.indexOf(urn);
        if (index > -1) {
            tempARR.splice(index, 1);
        } else {
            tempARR.push(urn);
        }
        setItemChecked(tempARR);
    }
    const onSelectAll = (e) => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            let urnArr = [];
            urnArr.push(autoShortlisted?.map(item => item?.urn));
            setItemChecked(...urnArr);
        } else if (selectAll) {
            setItemChecked([]);
        }
    }
    const onClickShortlistingCriteria = (e) => {
        e.preventDefault();
        setShortlistingCriteria(true);
        setShortlisting(false);
        setActive(true);
    }

    const onClickShortlisting = (e) => {
        e.preventDefault();
        setShortlistingCriteria(false);
        setShortlisting(true);
        setActive(false);
        if (!autoShortlisted || autoShortlisted.length == 0) {
            getStakeholdersSystemAutoShortlist();
        }
    }
    useEffect(() => {
        if (shortlistWaitlist) {
            if (shortlistWaitlist.isSuccess === true) {
                toast.success(action == SHORTLIST ? "Stakeholders shortlisted successfully" : "Stakeholders waitlisted successfully");
                getStakeholdersSystemAutoShortlist();
            } else {
                toast.error("An error occured while shortlisting stakeholders");
            }
        }

    }, [shortlistWaitlist]);

    useEffect(() => {
        if (updatePincode) {
            if (updatePincode.isSuccess === true) {
                toast.success("Shortlisting criteria saved successfully");
                getShortlistCriteria();
            } else {
                toast.error("An error occured while shortlisting stakeholders");
            }
        }

    }, [updatePincode]);

    const handleChange = (e) => {
        if (e.target.name === "pincode") {
            var slicedPincode = pincodeValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedPincode })
            if (slicedPincode.length != 6) {
                setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            }
            else {
                setErrorMessage({ ...errorMessage, pincodeError: "" });
            }

        }
        if (e.target.name === "pincode_search") {
            var slicedPincode = pincodeValidation(e.target.value);
            setPincodeSearch(slicedPincode);
        }
        if (e.target.name === "URN" || e.target.name === "stakeHolderType") {
            setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
        }
        if (e.target.name === "landAreaInSqft") {
            var slicedlandArea = pincodeValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedlandArea })
        }
        if (e.target.name === "noOfClumps") {
            var slicedClumps = pincodeValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedClumps })
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();
        handleConfirmLogModalOpen();
    }

    const searchPincode = (e) => {
        e.preventDefault();
        var arr;
        if (pincodeSearch.length > 0)
            arr = pincodeArr.filter((item) => item.pincode == pincodeSearch);
        else
            arr = pincodeArr;
        setPincodeArray(arr);
    }

    function shortListWaitListStakeholders() {
        loaderService.showLoader();
        const data = {
            "urnList": updateStakeholderStatus,
            "registrationStatus": action
        };
        apiClient
            .post(UPDATE_STAKEHOLDER_REGISTRATION_STATUS,
                data,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            ).then((response) => {
                setShortlistWaitlist(response.data);
                setSelectedRows([]);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
            });
    }

    const viewURNDetails = (urn) => {
        navigate("/registrationHome/shortlisting/viewPageWraper", { state: { urn: urn, tabValue: tabValue, page: page } });
    }

    function addShortlistingCriteria() {
        setSaveType("criteria");
        loaderService.showLoader()
        apiClient
            .post(ADD_SHORTLIST_CRITERIA,
                {
                    "landAreaInSqft": details.landAreaInSqft,
                    "landArea": "null",
                    "landAreaUnits": "null",
                    "noOfClumps": details.noOfClumps,
                    "pinCodes": updatedPincodes
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUpdatePincode(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    useEffect(() => {

        if (uploadDetails) {
            if (uploadDetails.isSuccess === false) {
                toast.error(uploadDetails?.message);
            }
            if (uploadDetails.isSuccess === true) {
                toast.success(uploadDetails?.message);
                getShortlistCriteria();
            }

        }

    }, [uploadDetails]);

    const handleChangePincode = (e) => {
        setErrorMessage({ ...errorMessage, fileuploadErrors: '' });
        setSelectedFile(e.target.files[0])
    };

    const onSubmitPincode = (e) => {
        if (selectedFile) {
            const extension = selectedFile.name.split('.').pop().toLowerCase();
            const isXlsFile = !!extension && extensionList.includes(extension);
            if (!isXlsFile) {
                setErrorMessage({ ...errorMessage, fileuploadErrors: "Only .xls, .xlsx, .xlsm files are allowed." });
                return;
            }
            else if (selectedFile.name.split('.').length > 2) {
                setErrorMessage({
                    ...errorMessage,
                    fileuploadErrors: "Double extension file detected.",
                });
                return;
            }
            else if (selectedFile.size >= 5000000) {
                setErrorMessage({ ...errorMessage, fileuploadErrors: "The file size should be less than 5MB." });
                return;
            }
            else if (fileNameValidation(selectedFile.name)) {
                setErrorMessage({ ...errorMessage, fileuploadErrors: FILE_NAME_VALIDATION_ERROR });
                return;
            }
            else {
                getexcelUploadDetails();
                e.preventDefault();
            }
        }
    };
    const AddPincode = (e) => {
        e.preventDefault();
        var arr = [...pincodeArray];
        if (details.pincode) {
            var pincodeArr = arr.filter((item) => item.pincode == details.pincode);
            if (!pincodeArr || pincodeArr.length == 0) {
                arr.push({
                    pincode: details.pincode,
                    isActive: true,
                    id: details.pincode,
                });
                setPincodeArray(arr);
                var tempArr = [...updatedPincodes];
                tempArr.push({
                    pincode: details.pincode,
                    isActive: true,
                });
                setUpdatedPincodes(tempArr);
                setDetails({ ...details, pincode: "" });
            }
        }

    }
    function getexcelUploadDetails() {
        const formData = new FormData();
        formData.append("file", selectedFile);
        apiClient
            .post(ADD_BULK_PINCODE, formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                setUploadDetails(response.data)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const columns = [
        { field: 'pincode', headerName: 'Allowed Pincode', width: 220 },
        {
            field: 'Action', width: 150,
            renderCell: (index) => {
                return (
                    <Tooltip title="Delete">
                        <IconButton style={{ color: 'red' }} onClick={() => onDeletePincode(index?.row?.pincode)} component="label">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                );

            }
        },
    ];

    const ShortlistingCol = [
        {
            field: 'name', headerName: t('preReg.name'), width: 180,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.row.growerType && params.row.growerType.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name}
                </div>),
            valueGetter: (params) => params.row.growerType && params.row.growerType.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name
        },
        { field: 'categoryName', headerName: 'Stakeholder Type', width: 190 },
        { field: 'growerType', headerName: 'Sub-Category', width: 190 },
        {
            field: 'urn', headerName: 'URN', width: 180,
            sortComparator: (a, b) => lastFiveDigitsComparator(a, b), renderCell: (params) => { return (<Link to={params} onClick={() => { viewURNDetails(params?.row?.urn) }}>{params.value}</Link>) }
        },
        { field: 'state', headerName: 'State', width: 180 },
        { field: 'district', headerName: 'District', width: 220 },
        { field: 'revenueCircle_BlockName', headerName: 'Revenue Circle', width: 220 },
        { field: 'registrationStatus', headerName: 'System Eligibility', width: 220 },
    ];

    return (
        <div>
            <Container fluid>
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG55</p>}
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                            <Tab label="Shortlisting Criteria" value="1" />
                            <Tab label="Shortlisting" value="2" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                        <Card>
                            <CardContent>
                                <a style={{ display: "flex", flexDirection: "row" }} href='https://abrplscmsandbox.blob.core.windows.net/stakeholdertemplate/PincodeTemplate.xlsm'>
                                    <DownloadIcon /> <Typography variant="subtitle1">Download Pincode Template.</Typography></a>
                                <Typography variant="subtitle2" mt={2}>Upload Pincode file</Typography>
                                <Box mt={1}>
                                    <label className="ChooseFileInputAdminPincode">
                                        <input style={{ fontSize: '2vh' }} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => handleChangePincode(e)} name="Bulk_upload" />
                                    </label>
                                    <Button startIcon={<UploadIcon />} variant="contained" style={{ marginLeft: '2vh' }} onClick={(e) => onSubmitPincode(e)}>Upload</Button>
                                    <Col xs={12} md={12}><Typography variant="subtitle2" fontSize="1.8vh" color="green">(upload only .xls, .xlsx, .xlsm files.File size limit=5MB)</Typography></Col>
                                    <Typography variant="subtitle2" fontSize="1.8vh" color="red">{errorMessage.fileuploadErrors}</Typography>
                                </Box>
                                <Typography variant="subtitle2" mt={3}>Add Pincode</Typography>
                                <Stack display='flex' direction="row" alignItems="center" spacing={2} mt={1}>
                                    <TextField
                                        error={errorMessage.pincodeError}
                                        helperText={errorMessage.pincodeError}
                                        type='number'
                                        onFocus={handleNumberFieldFocus}
                                        name="pincode"
                                        value={details.pincode}
                                        label="Enter Pincode"
                                        onKeyDown={(evt) => typeNumberValid(evt)}
                                        onChange={(e) => handleChange(e)} />
                                        <BadgeComponent currentLength={details?.pincode?.length} maxLength={pincodeMaxLength} />
                                    <Button startIcon={<AddIcon />} variant="contained" onClick={(e) => AddPincode(e)} >Add</Button>
                                </Stack>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={6}>
                                        <Box mt={2} sx={{
                                            height: 450, width: '100%',
                                            '& .MuiDataGrid-cell--editable': {
                                                bgcolor: (theme) =>
                                                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                            },
                                        }}>
                                            {
                                                pincodeArray &&
                                                <DataGrid
                                                    rows={pincodeArray}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}

                                                />
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} lg={3} mt={2}>
                                        <Stack spacing={2}>
                                            <TextField
                                                error={errorMessage.clumpsError}
                                                helperText={errorMessage.clumpsError}
                                                type='number'
                                                onFocus={handleNumberFieldFocus}
                                                name="noOfClumps"
                                                value={details.noOfClumps}
                                                label="Number of Clumps"
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => typeNumberValid(evt)} />
                                                <BadgeComponent currentLength={details?.noOfClumps?.length} maxLength={mobileNoMaxLength} />
                                            <TextField
                                                error={errorMessage.landareaError}
                                                helperText={errorMessage.landareaError}
                                                type='number'
                                                onFocus={handleNumberFieldFocus}
                                                name="landAreaInSqft"
                                                value={details.landAreaInSqft}
                                                label="Land Area in Sqft"
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => typeNumberValid(evt)} />
                                                <BadgeComponent currentLength={details?.landAreaInSqft?.length} maxLength={mobileNoMaxLength} />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                            <Button startIcon={<SaveIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSubmit(e)}>Save</Button>
                        </Box>
                    </TabPanel>
                    <TabPanel value="2" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                        <Card>
                            <CardContent>
                                <Grid container direction="row" spacing={1} display="flex" alignItems="center">
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>Stakeholder Type</InputLabel>
                                            <Select name='stakeHolderType' label="Stakeholder Type" onChange={(e) => handleChange(e)} value={searchFilter.stakeHolderType}>
                                                {Stakeholder_Type.map((item) => <MenuItem value={item} key={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth type="text" label="URN" name="URN" value={searchFilter.URN} onChange={(e) => handleChange(e)} />
                                        
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <Button startIcon={<SearchIcon />} variant="contained" onClick={(e) => searchShortlist(e)} >Search</Button>
                                    </Grid>
                                </Grid>
                                <Box sx={{ height: 400, width: '100%' }} mt={2}>
                                    {
                                        autoShortlisted &&
                                        <DataGrid
                                            sx={{
                                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                                            }}
                                            getRowHeight={() => 'auto'}
                                            rows={autoShortlisted}
                                            page={page}
                                            onPageChange={(newPage) => setPage(newPage)}
                                            columns={ShortlistingCol}
                                            pageSize={10}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                            initialState={{
                                                sorting: {
                                                    sortModel: [{ field: 'registrationStatus', sort: 'desc' }],
                                                },
                                            }}
                                            // isRowSelectable={(params) => ((params?.row?.registrationStatus === "Waitlisted" || params?.row?.registrationStatus === "Pre_Registration_Initiated") && (selectedRows?.length < shortListWaitlistMaxcount || selectedRows.includes(params.row.urn)))}
                                            isRowSelectable={(params) => ((selectedRows?.length < shortListWaitlistMaxcount || selectedRows.includes(params.row.urn)))}
                                            checkboxSelection
                                            onSelectionModelChange={(newSelection) => {
                                                if (newSelection.length > shortListWaitlistMaxcount) {
                                                    // Only keep the first 50 selected checkboxes
                                                    newSelection = newSelection.slice(0, shortListWaitlistMaxcount);
                                                }
                                                setSelectedRows(newSelection.map(row => {
                                                    let urnSelected = ""
                                                    autoShortlisted.forEach(item => {
                                                        if (row === item.id) {
                                                            urnSelected = item.urn;
                                                        }
                                                    })
                                                    return urnSelected;
                                                }));
                                            }} />
                                    }
                                </Box>
                            </CardContent>
                        </Card>
                        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                            <Button startIcon={<ShortlistIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onClickShortlistWaitlist(e, SHORTLIST)}>Shortlist</Button>
                            <Button startIcon={<WaitlistIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onClickShortlistWaitlist(e, WAITLIST)}>Waitlist</Button>
                        </Box>
                    </TabPanel>
                </TabContext>
            </Container>
            <ConfirmationPopover onOpen={logConfirmModalOpen} action="Submit" onConfirm={onConfirmCallBack} onClose={handleConfirmLogModalClose} />
        </div>
    )
}

export default Shortlisting;
